import { Icon } from "components";
import { CIRCLE_X } from "icons";
import { CircleXIcon } from "lucide-react";
import { Button } from "ui";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from "ui/components/select";
import { cn } from "utils";

export default function TimesheetSelect({
  placeholder = "Select",
  value,
  onValueChange,
  items,
  disabled = false,
  groupLabel,
  required = false,
  className = "max-w-80",
  displayProperty = "name",
}) {
  return (
    <Select
      disabled={disabled}
      onValueChange={onValueChange}
      value={value}
      required={required}
    >
      <div className="relative w-full min-w-0">
        <SelectTrigger
          className={cn(
            "w-full overflow-hidden whitespace-normal",
            "[&_[data-slot=select-value]]:block",
            "[&_[data-slot=select-value]]:truncate",
            className,
          )}
          value={value}
        >
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>
        {value && (
          <Button
            variant="ghost"
            className="absolute right-0 inset-y-0 hover:bg-transparent"
            onClick={(e) => {
              e.stopPropagation();
              onValueChange(undefined);
            }}
          >
            <Icon icon={CIRCLE_X} className="h-4 w-4 opacity-50" />
          </Button>
        )}
      </div>
      <SelectContent className="w-full">
        <SelectGroup>
          {groupLabel && <SelectLabel>{groupLabel}</SelectLabel>}
          {items?.map((item) => (
            <SelectItem key={item.id} value={item.id}>
              {item[displayProperty]}
            </SelectItem>
          ))}
        </SelectGroup>
      </SelectContent>
    </Select>
  );
}
